/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */

export const FadeDivider = () => {
  return (<div className="fade-divider"></div>)
}